// removed by extract-text-webpack-plugin
module.exports = {"chapter-selector":"_7u2594Llay-2gJ6SvUYMo","chapter-selector__backdrop":"_3t_g_px79G1sWuuaVYV0_S","active":"_3hk0_PB6YhsTwLvqH5K7Tz","chapter-selector__dropdown-toggle":"JXoPUXz-QFNWmTYXvzQrl","chapter-selector__dropdown":"_3G7Wuf1YqtZdQIoX3Yzm8I","chapter-selector__dropdown__title":"_2sDXK2-htjR1LQp0sx7rkJ","chapter-selector__dropdown__item":"_2KB9oEF29-XauBZfOyToRg","toggle":"_30X4yjUP0uq9Mc05bVDA4f","number":"_36uXHbp1EWfb3-ckhb6Ikj","title":"_3yjQ0WY-mxGCnWWEuUAdGx","brief-info":"_3wKwnaSh2rha9GBGG1mS_o","dropdown":"_3oWcA_U-khudFIywq-TZs8","dropdown__item":"_2rQSAvp9HC2cJYOLYuCwBL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChapterSelector/chapter-selector.scss
// module id = 1728
// module chunks = 0